import { render, staticRenderFns } from "./UserPayrollAdjustment.vue?vue&type=template&id=a784eaf0&scoped=true&"
import script from "./UserPayrollAdjustment.vue?vue&type=script&lang=ts&"
export * from "./UserPayrollAdjustment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a784eaf0",
  null
  
)

export default component.exports